import React from "react";
import { Layout, Typography, Row, Col, Button, Space } from "antd";
import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";
import "./BanhoDeOuroSemijoias.css";
import PorqueEscolher from "../components/components/porque_escolher/banho_ouro/porqueescolher";
import ComoFunciona from "../components/components/como_funciona/comoFunciona";
import ProofResultsSection from "../components/components/prova_social/ProofResultsSection";
import WhoWeServeSection from "../components/pra_quem-serve/WhoWeServeSection";
import FAQSection from "../components/components/FAQ/FAQSection.js";
import FloatingCTA from "../components/components/common/FloatingCTA.js";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

function BanhoSemijoias() {
  return (
    <Layout>
      <MainHeader />
      <FloatingCTA triggerId="trigger-floating-cta" />

      <Content>
        <section className="section-banho-ouro">
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <Row gutter={[40, 40]} align="middle">
              <Col xs={24} md={14}>
                <Title style={{ color: "#fff", fontSize: 48, lineHeight: 1.1 }}>
                  <span className="p-titulo">Banho de Ouro</span> para Semijoias com acabamento <span className="p-titulo">premium</span>
                </Title>
                <Paragraph style={{ color: "#ffffffd9", fontSize: 18 }}>
                  Serviço especializado para marcas e fabricantes que precisam de
                  brilho, uniformidade, controle técnico e padrão de qualidade.
                </Paragraph>

                <Space wrap>
                  <Button className="btn-ouro" size="large">
                    Solicitar orçamento
                  </Button>
                </Space>
              </Col>

              <Col xs={24} md={10}>
                <div
                  style={{
                    minHeight: 360,
                    background: "#2a2a2a",
                    borderRadius: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#d4b483",
                  }}
                >
                  Imagem do serviço
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <PorqueEscolher />
        <section id="trigger-floating-cta">
          <ComoFunciona />
        </section>
        <ProofResultsSection />
        <WhoWeServeSection />
        <FAQSection />
      </Content>

      <MainFooter />
    </Layout>
  );
}

export default BanhoSemijoias;